export default "__VITE_ASSET__CvWfaQW4__"